import React  from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faChevronDown } from '@fortawesome/free-solid-svg-icons'

import './product_menu.scss'

const ProductMenuLabel = () => {
  const classes = ['product-menu-label']
  /*if (display) {
    classes.push('active')
  }*/

  return (
    <h6 className={classes.join(' ')}>
      <button>
        <FontAwesomeIcon style={{
          fontSize: '20px',
          verticalAlign: 'top'
        }} icon={faBars} />
        Shop Products
        <FontAwesomeIcon icon={faChevronDown} />
      </button>
    </h6>
  )
}

export default () => {
  return <ProductMenuLabel />
}
